import * as React from "react";

export const AddNewButton = (props: any) => {
    return (
        <div className="row narrow-gutter row-right vspace-24">
        <div className="col-auto"></div>
        <div className="col-auto">
            <button
                className="btn small secondary"
                onClick={() => props.onClick()}
                disabled={props.isReview}
            >
                {props.name}
            </button>
        </div>
    </div>
    );
};
